import React, { useState } from 'react'
import Chart from 'react-apexcharts'

export default function LineChart() {
    const option = {
        series: [{
            name:"kWh",
            data:[
                [1641034800000, 30.95],
                [1641380400000, 31.34],
                [1641812400000, 31.18],
                [1642244400000, 31.05],
                [1642676400000, 31.00],
                [1643108400000, 30.95],
                [1643540400000, 31.24],
                [1643713200000, 31.29],
                [1644490800000, 31.85],
                [1645354800000, 31.86],
                [1646046000000, 32.28],
                [1646305200000, 32.10],
                [1647082800000, 32.65],
                [1647946800000, 32.21],
                [1648893600000, 32.35],
                [1649671200000, 32.44],
                [1650708000000, 32.46],
                [1651312800000, 32.86],
                [1651572000000, 32.75],
                [1652349600000, 32.54],
                [1652781600000, 32.33],
                [1653300000000, 32.97],
                [1653645600000, 33.41],
                [1654077600000, 33.27],
                [1654768800000, 33.27],
                [1655805600000, 32.89],
                [1656496800000, 33.10],
                [1656842400000, 33.73],
                [1657706400000, 33.22],
                [1658570400000, 31.99],
                [1659607200000, 32.41],
                [1660471200000, 33.05],
                [1661335200000, 33.64],
                [1662372000000, 33.56],
                [1663236000000, 34.22],
                [1664100000000, 33.77],
                [1664704800000, 34.17],
                [1664964000000, 33.82],
            ]
        }],
        options: {
            chart: {
                id: 'area-datetime',
                type: 'area',
                height: 350,
                zoom: {
                    autoScaleYaxis: true
                }
            },
            dataLabels: {
                enabled: false
            },
            markers: {
                size: 0,
                style: 'hollow',
            },
            xaxis: {
                type: 'datetime',
                min: new Date('01 Jan 2022').getTime(),
                tickAmount: 6,
            },
            tooltip: {
                x: {
                    format: 'dd MMM yyyy'
                }
            },
            fill: {
                type: 'gradient',
                gradient: {
                    shadeIntensity: 1,
                    opacityFrom: 0.7,
                    opacityTo: 0.9,
                    stops: [0, 100]
                }
            },
        },
        selection: 'one_year',

    };

    return (
        <div>
           <Chart options={option.options} series={option.series} type="area" height={320} />
        </div>

    );

}